/**
 * Texts for Training page
 */
export const trainingPageText = {
    title: 'Oplæring – CamAPS FX',
    titleMeta: 'Vi sørger for gratis onlineoplæring til CamAPS FX-brugere',
    descriptionMeta: 'Cambridge Diabetes Education Programme udbyder gratis certificeret onlineoplæring til mennesker med type 1-diabetes, forældre og værger, skolepersonale og behandlere.',
    keywords: 'camps træning, camps fx træning, ',
    localeMeta: 'da_dk',
    mainHeader: 'Sundhedstræning',
    mainSubHeader: 'Støt personer, der bruger CamAPS FX, med ekspertledet træning.',
    gettingStartedHeader: 'Kom i gang',
    step1Title: '<strong>Trin 1:</strong><br/>Download appen',
    step2Title: '<strong>Trin 2:</strong><br/>Opret en konto',
    step3Title: '<strong>Trin 3:</strong><br/>Begynd den væsentlige træning i appen',
    step4Title: '<strong>Trin 4:</strong><br/>Par med din valgte pumpe og CGM (med godkendelse fra dit sundhedsteam) eller udforsk appen med <strong>virtuel tilstand</strong>',
    videoSrc: '/video/In-app training loop_1.mp4',
    certifiedTrainingTitle: 'Certificeret oplæring',
    trainingHeader: 'Certificeret oplæring',
    trainingHeader_2: 'For behandlere',
    trainingHeader_3: 'Brugeruddannelse',
    trainingHeaderText: 'GRATIS CamAPS FX-onlineoplæring leveret af Cambridge Diabetes Education Programme (CDEP).',
    websiteLink: 'https://www.camdiabtraining.com/account-sign-in.html',
    websiteLinkHeading: 'CDEP-oplæring',
    getTrained: 'Bliv oplært',
    trainingHeaderIat: 'CamAPS FX træning',
    trainingHeaderTextIat: 'Fuldfør den essentielle træning i appen, før du bruger CamAPS FX-appen.',
    trainingSubHeaderOneIat: 'Kom godt i gang',
    trainingSubTextOneIat: 'Download CamAPS FX-appen. <br>Opret en konto for at starte træningen.',
    trainingSubHeaderTwoIat: 'Brug for hjælp til at installere appen?',
    trainingParaTwoStartIat: 'Besøg vores',
    trainingParaTwoEndIat: 'sektion for vejledning.',
    websiteLinkHeadingSupportIat: 'Support',
    trainingSubHeaderThreeIat: 'Yderligere ressourcer',
    animationsYpsoPumpText: 'Animationer',
    animationsAndText: 'og',
    animationsDanaText: 'Animationer (Dana-pumpen)',
    animationsFurtherText: 'Lær gennem trin-for-trin visuelle guider.',
    webinarsText: 'Webinarer',
    webinarsFurtherText: 'Se ekspertledede sessioner om brug af appen.',
    websiteAnimationsYpsoPumpLink: 'https://www.camdiabtraining.com/view/27/mylife-YpsoPump-users.htm',
    websiteAnimationsDanaLink: 'https://www.camdiabtraining.com/view/25/Dana-insulin-pump-users.htm',
    websiteWebinarsLink: 'https://www.camdiabtraining.com/view/20/Webinars.htm',
};
